module.exports = __webpack_public_path__ + "img/flights.b82bf18f.svg";